// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Notice-module__root--R4Q3H {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  min-height: 170px;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  color: #777;
  font-size: 0.9375rem; /* 15px */
  font-weight: 400;
  line-height: 1.5385;
  text-align: center;
  overflow-wrap: anywhere;
}

.Notice-module__surface-filled--rfKqK {
  border-radius: 12px;
  background-color: var(--chaek-color-surface-subtle);
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Notice/Notice.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,oBAAoB,EAAE,SAAS;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,mDAAmD;AACrD","sourcesContent":[".root {\n  box-sizing: border-box;\n  display: flex;\n  width: 100%;\n  min-height: 170px;\n  align-items: center;\n  justify-content: center;\n  padding: 32px 16px;\n  color: #777;\n  font-size: 0.9375rem; /* 15px */\n  font-weight: 400;\n  line-height: 1.5385;\n  text-align: center;\n  overflow-wrap: anywhere;\n}\n\n.surface-filled {\n  border-radius: 12px;\n  background-color: var(--chaek-color-surface-subtle);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Notice-module__root--R4Q3H`,
	"surface-filled": `Notice-module__surface-filled--rfKqK`
};
export default ___CSS_LOADER_EXPORT___;
